const on = (
  container: HTMLElement,
  eventName: string,
  handler: EventListener,
) => {
  container.addEventListener(eventName, handler);
  return () => {
    container.removeEventListener(eventName, handler);
  };
};

const onDnDDragEnd = (container: HTMLElement, callback: () => void) => {
  // Drag onto child elements can also trigger "dragleave" so we track how
  // many times "dragenter" is triggered.
  let enterTimes = 0;

  // "dragleave" won't be fired when dragging over iframes (e.g. Video blot) on Firefox,
  // so the timer is used as a fallback.
  let cancelTimeout: ReturnType<typeof setTimeout> | null = null;
  const invalidateCancelTimeout = () => {
    if (cancelTimeout) {
      clearTimeout(cancelTimeout);
      cancelTimeout = null;
    }
  };

  const extendCancelTimeout = () => {
    invalidateCancelTimeout();
    cancelTimeout = setTimeout(() => {
      endDragging();
    }, 1000);
  };

  const endDragging = () => {
    enterTimes = 0;
    invalidateCancelTimeout();
    callback();
  };

  const offs = [
    on(container, 'drop', () => {
      endDragging();
    }),
    on(container, 'dragenter', () => {
      enterTimes += 1;
      extendCancelTimeout();
    }),
    on(container, 'dragover', () => {
      extendCancelTimeout();
    }),
    on(container, 'dragleave', () => {
      enterTimes -= 1;
      if (enterTimes <= 0) {
        endDragging();
      }
    }),
  ];

  return () => {
    offs.forEach((off) => {
      off();
    });
    invalidateCancelTimeout();
  };
};

export default onDnDDragEnd;
